export default __webpack_public_path__ + "static/media/blue_rocket.d7e8b26a.svg";